"use client";

import { SquareTerminalIcon } from "lucide-react";

import type { CodeExecutionResultContentBlock } from "../../types";
import { cn, truncate } from "../../utils";
import { CollapsibleSection } from "../CollapsibleSection";

interface CodeExecutionResultBlockProps {
  block: CodeExecutionResultContentBlock;
  isStreaming?: boolean;
}

export const CodeExecutionResultBlock = ({
  block,
  isStreaming,
}: CodeExecutionResultBlockProps) => {
  const isSuccess = block.outcome === "success";
  const preview = truncate(block.output);

  return (
    <CollapsibleSection
      icon={<SquareTerminalIcon className="h-3 w-3" />}
      label="Output"
      preview={preview}
      copyContent={block.output}
      isStreaming={isStreaming}
    >
      <div className="flex flex-col gap-1.5">
        <span
          className={cn(
            "inline-flex w-fit rounded-full px-2 py-0.5 text-[10px] font-medium",
            isSuccess ? "bg-green-50 text-green-600" : "bg-red-50 text-red-600",
          )}
        >
          {block.outcome}
        </span>
        <pre className="overflow-x-auto rounded-md bg-zinc-100 p-2 font-mono text-xs text-zinc-800">
          {block.output}
        </pre>
      </div>
    </CollapsibleSection>
  );
};
